import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import validator from 'validator';

const UserRegistration = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    name: '',
    google_scholar_profile: '',
  });
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [error, setError] = useState(null);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));

    if (name === 'username') {
      const isValidEmail = validator.isEmail(value);
      setIsEmailValid(isValidEmail);
      if (!isValidEmail) {
        setError('Please enter a valid email address.');
      } else {
        setError(null);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isEmailValid) {
      return;
    }
    setIsLoading(true);
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      if (!response.ok) {
        if (response.status === 409) {
          throw new Error('A user with this username already exists. Please try a different username.');
        } else {
          throw new Error('Registration failed due to server error.');
        }
      }
  
      await response.json();
      setRegistrationSuccess(true);
      setError(null);
      navigate('/login');
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };  

  return (
    <div>
      <div className="login-title">
        <h1>Register</h1>
      </div>
      {registrationSuccess ? (
        <div className="success-message">Registration successful!</div>
      ) : (
        <>
          <form onSubmit={handleSubmit} className="user-registration-form">
            {error && <div className="error">{error}</div>}
            <label htmlFor="username">Email:</label>
            <input name="username" type="email" value={formData.username} onChange={handleChange} required />

            <label htmlFor="password">Password:</label>
            <input name="password" type="password" value={formData.password} onChange={handleChange} required />

            <label htmlFor="name">Name (Optional):</label>
            <input name="name" type="text" value={formData.name} onChange={handleChange} />

            <label htmlFor="google_scholar_profile">Google Scholar Profile URL (Optional):</label>
            <input name="google_scholar_profile" type="text" value={formData.google_scholar_profile} onChange={handleChange} />

            <div className="button-container">
              <button className="login-button" type="submit" disabled={isLoading || !isEmailValid}>
                {isLoading ? 'Registering...' : 'Register'}
              </button>
            </div>
          </form>
        </>
      )}
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default UserRegistration;
